import { breakpointMd, breakpointLg } from 'theme/breakpoints';

export const scrollTop = () => window.scrollTo(0, 0);

export const isMobile = ({ largeMobile = true } = {}) =>
  window.innerWidth <= (largeMobile ? breakpointLg : breakpointMd);
